// extracted by mini-css-extract-plugin
export default {"root":"ProgressCirle_root__RTza4","children":"ProgressCirle_children__txMrT","text":"ProgressCirle_text__EhSBw","progress":"ProgressCirle_progress__H5gw6"};